const permissionTable = {
    default: [
        'authorizationRoles:read',
        'companies:read',
        'companies:readAccount',
        'companies:register',
        'healthdashboard:read'
    ],
    reportsRead: [
        'reports:read',
        'workerProcess:read'
    ],
    reportsFull: [
        'reports:read',
        'reports:full',
        'workerProcess:read'
    ],
    rulesRead: [
        'agents:read',
        'area:read',
        'campus:read',
        'clients:read',
        'equipment:read',
        'rule:read',
        'sensors:read',
        'sites:read',
        'system:read'
    ],
    rulesFull: [
        'agents:read',
        'area:read',
        'campus:read',
        'clients:read',
        'equipment:read',
        'rule:full',
        'rule:read',
        'sensors:read',
        'sites:read',
        'system:read'
    ],
    adminRead: [
        'authorizationRoles:read',
        'authorizationScopes:read',
        'companies:readAccount'
    ],
    adminFull: [
        'authorizationRoles:deregister',
        'authorizationRoles:modify',
        'authorizationRoles:read',
        'authorizationRoles:register',
        'authorizationScopes:read',
        'companies:deregister',
        'companies:grantAccess',
        'companies:modify',
        'companies:readAccount',
        'companies:resendInvitation',
        'companies:revokeAccess'
    ],
    homeRead: [
        'area:read',
        'campus:read',
        'clients:read',
        'equipment:read',
        'health:read',
        'sensors:read',
        'sites:read',
        'system:read'
    ],
    homeFull: [
        'area:read',
        'campus:read',
        'clients:read',
        'equipment:read',
        'health:full',
        'health:read',
        'sensors:read',
        'sites:read',
        'subscription:post',
        'system:read'
    ],
    iothubRead: [
        'agents:read'
    ],
    iothubFull: [
        'agents:full',
        'agents:read'
    ],
    imageStorageRead: [
        'itemStorage:read'
    ],
    imageStorageFull: [
        'imageStorage:full'
    ],
    architectRead: [
        'agents:read',
        'area:read',
        'campus:read',
        'clients:read',
        'equipment:read',
        'sensors:read',
        'sites:read',
        'system:read'
    ],
    architectFull: [
        'agents:read',
        'area:full',
        'area:read',
        'campus:full',
        'campus:read',
        'clients:deregister',
        'clients:linkSite',
        'clients:modify',
        'clients:read',
        'clients:register',
        'clients:unlinkSite',
        'equipment:deregister',
        'equipment:modify',
        'equipment:read',
        'equipment:register',
        'equipmentTypes:read',
        'sensors:full',
        'sensors:read',
        'sites:deregister',
        'sites:modify',
        'sites:read',
        'sites:register',
        'system:full',
        'system:read'
    ],
    subscriptionRead: [
        'subscription:get'
    ],
    subscriptionFull: [
        'subscription:post',
        'subscription:put',
        'subscription:delete',
        'subscription:get',
    ],
    serviceManagementRead: [
        'serviceManagement:read'
    ],
    serviceManagementFull: [
        'serviceManagement:read',
        'serviceManagement:full'
    ]
};

const PermissionTypes = Object.keys(permissionTable);

const Permissions = permissionLabel => {
    return permissionTable[permissionLabel];
};

export { Permissions, PermissionTypes };
